import { Controller } from "stimulus";
import { Formio } from "formiojs";
import FormioUtils from "formiojs/utils";
import BaseFileModule from "./shared_modules/base_file_module.js";
import FormStateModule from "./shared_modules/form_state_module.js";
import NotificationModule from "./shared_modules/notification_module.js";
import FormSubmissionModule from "./shared_modules/form_submission_module.js";
import CornerstoneGradingModule from "./shared_modules/cornerstone_grading_module";
import FileProcessingModule from "./shared_modules/file_processing_module.js";
import ToggleModule from "./shared_modules/toggle_module.js";
import RFCModule from "./shared_modules/rfc_module.js";
import PrintFormModule from "./shared_modules/print_form_module.js";
import FormAuditHistoryModule, {
  buildAuditHistoryJsonUrl,
} from "./shared_modules/form_audit_history_module.js";
import PreviousVisitValidationModule from "./shared_modules/previous_visit_validation_module.js";
import { event } from "jquery";
export default class extends Controller {
  static targets = [
    "viewer",
    "url",
    "form",
    "path",
    "agreement",
    "imageTag",
    "submit",
    "update",
    "menu",
    "cornerstone",
    "formSection",
    "menuIcon",
    "cornerstoneIcon",
    "questionArea",
    "loadingImage",
    "button",
    "thumb",
    "auditHistory",
    "changeSummary",
  ];

  async initialize() {
    // Define Targets
    const elem = this.viewerTarget;
    this.imagesMenu = this.menuTarget;
    this.cornerstoneImages = this.cornerstoneTarget;
    this.formSection = this.formSectionTarget;
    this.gradingFormElem = this.formTarget;
    // Optional in view_only (submit panel may be omitted); missing target previously left the loader spinning
    this.gradingFormAgreementElem = this.hasAgreementTarget
      ? this.agreementTarget
      : null;
    this.imageTag = this.hasImageTagTarget ? this.imageTagTarget : null;
    this.viewerElement = elem;
    this.gradingSaveUrl =
      document.location.origin + this.data.get("updatePath") + ".json";
    this.gradingFormExistUrl =
      document.location.origin + this.data.get("gradingFormPath");
    this.gradingPreviousUrl =
      document.location.origin + this.data.get("previousAns") + ".json";
    const previousVisitGradingPath = this.data.get("previousVisitGradingUrl");
    this.previousVisitGradingUrl = previousVisitGradingPath
      ? document.location.origin + previousVisitGradingPath
      : null;
    this.previousVisitValidationModule = null;
    const rfcHistoryPath = this.data.get("cornerstoneGradeRfcHistory");
    this.gradingRfcHistory = rfcHistoryPath
      ? document.location.origin + rfcHistoryPath + ".json"
      : null;
    this.graderNameUrl =
      document.location.origin + this.data.get("graderNamePath") + ".json";
    this.formMode = this.data.get("mode");
    this.gradingFormUserId = this.data.get("userId");
    this.pdfIcon = this.data.get("pdfIcon");
    this.gradingFormStackId = this.data.get("stackId");
    this.viewerStatus = this.data.get("viewerStatus");
    this.releaseEye = this.data.get("releaseEye");
    const shouldProcessIGMP =
      this.data.get("mode") === "create" ||
      this.data.get("status") === "initiated";
    if (shouldProcessIGMP) {
      const rawMessages = this.data.get("igmpAutograderApiErrors");
      const messages = JSON.parse(rawMessages || "{}");
      const errors = messages.errors || [];
      const warnings = messages.warnings || [];

      // Build HTML for SweetAlert
      let alertHtml = "";

      if (errors.length > 0) {
        alertHtml += "<strong>Errors:</strong><ul>";
        errors.forEach((error) => {
          alertHtml += `<li>${error.message || error}</li>`;
        });
        alertHtml += "</ul>";
      }

      if (warnings.length > 0) {
        alertHtml += "<strong>Warnings:</strong><ul>";
        warnings.forEach((warning) => {
          alertHtml += `<li>${warning}</li>`;
        });
        alertHtml += "</ul>";
      }

      // Only show alert if there are errors or warnings
      if (alertHtml) {
        Swal.fire({
          title: "Attention",
          html: alertHtml,
          icon: "warning",
          confirmButtonText: "Continue",
          allowOutsideClick: false, // cannot click outside to close
          allowEscapeKey: false, // cannot close with ESC
        }).then((result) => {
          if (result.isConfirmed) {
            console.log("User clicked Continue");
            // proceed further
          } else {
            console.log("User cancelled");
          }
        });
      }
    }
    const imageKeys = this.data.get("imageKeys");
    this.donwloadUrl = this.data.get("downloadAnnotationPath");
    this.gradingFormUserId = this.data.get("userId");
    this.gradingFormStackId = this.data.get("stackId");
    this.filename = this.data.get("fileName");
    this.apiUrl = `${this.data.get("apiUrl")}iol/angle-calculation`;
    if (imageKeys && imageKeys.trim() !== "[]") {
      // Split the string by commas and remove any leading/trailing spaces, then filter out empty strings
      this.gradingImages = imageKeys
        .split(",")
        .map((key) => key.trim())
        .filter(Boolean);
    } else {
      // If imageKeys is not provided or is empty/contains only [], set this.gradingImages to an empty array
      this.gradingImages = [];
    }
    this.images = [];
    this.readImages();
    this.currentImage = 0;
    this.gradingFormVersionId = this.data.get("versionId");
    // load previously saved grading data if available
    try {
      const annotationData = this.data.get("annotation") || "{}";
      this.annotation = JSON.parse(annotationData);
      // Debug: log if annotations are empty
      if (Object.keys(this.annotation).length === 0) {
        // console.log("No annotations found in data");
      }
    } catch (e) {
      console.error(
        "Error parsing annotation data:",
        e,
        "Raw data:",
        this.data.get("annotation"),
      );
      this.annotation = {};
    }

    try {
      const ellipseDataStr = this.data.get("ellipseData") || "{}";
      this.ellipseData = JSON.parse(ellipseDataStr);
      // Debug: log if ellipse data is empty
      if (Object.keys(this.ellipseData).length === 0) {
      }
    } catch (e) {
      console.error(
        "Error parsing ellipse data:",
        e,
        "Raw data:",
        this.data.get("ellipseData"),
      );
      this.ellipseData = {};
    }
    // Check if ellipseData is not an empty object
    // Call toggleTags programmatically
    this.toggleModule = new ToggleModule({
      button: this.buttonTarget,
      thumb: this.thumbTarget,
      toggleSelector: ".additional-tools",
      disableTools: document.getElementsByClassName("disableTools"),
      ellipseData: this.ellipseData,
    });

    this.gradingFormSchema = JSON.parse(this.data.get("gradingForm"));
    // Store the original unfiltered schema for printing without data
    this.originalGradingFormSchema = JSON.parse(
      JSON.stringify(this.gradingFormSchema),
    );

    this.StudyEye = this.data.get("studyEye");
    this.CheckEye = this.data.get("checkEye");
    if (this.CheckEye == "Study Eye") {
      const updatedComponents = [];
      this.gradingFormSchema.components.forEach((multiple_trials) => {
        if (
          multiple_trials["key"].slice(-2).toLowerCase() == this.StudyEye ||
          this.StudyEye == "ou" ||
          (multiple_trials["key"].slice(-2).toLowerCase() != "od" &&
            multiple_trials["key"].slice(-2).toLowerCase() != "os")
        ) {
          updatedComponents.push(multiple_trials);
        }
      });
      this.gradingFormSchema["components"] = updatedComponents;
    } else {
      const updatedComponents = [];
      this.gradingFormSchema.components.forEach((multiple_trials) => {
        if (
          multiple_trials["key"].slice(-2).toLowerCase() == this.releaseEye ||
          this.releaseEye == "ou" ||
          (multiple_trials["key"].slice(-2).toLowerCase() != "od" &&
            multiple_trials["key"].slice(-2).toLowerCase() != "os")
        ) {
          updatedComponents.push(multiple_trials);
        }
      });
      this.gradingFormSchema["components"] = updatedComponents;
    }
    this.gradingFormResponses = JSON.parse(this.data.get("responses"));
    this.gradingFormSaveUrl =
      document.location.origin + this.data.get("formUpdatePath") + ".json";
    // renderer
    this.gradingForm = await Formio.createForm(
      this.gradingFormElem,
      this.gradingFormSchema,
      {
        noAlerts: true,
        readOnly: this.data.get("readOnly") === "true" || new URLSearchParams(window.location.search).get("page_type") === "view_only",
      },
    );
    this.gradingForm.submission = this.gradingFormResponses;
    this.formSaveDraftStatus = false;
    const displayImagesForQuestions = (
      formComponents,
      gradingFormResponses,
      ImagesArray,
    ) => {
      // Split the string into an array of URLs using a comma as the separator
      const imagesArray = ImagesArray.split("<==>").map((url) => url.trim());
      // Iterate through the form components
      FormioUtils.eachComponent(formComponents, (component) => {
        // Check if the component key is in gradingFormResponses
        if (component.key in gradingFormResponses.data) {
          const questionKey = component.key;
          const verified_key = questionKey + "_sdv_verified";
          const comments_key = questionKey + "_sdv_comments";
          if (gradingFormResponses.sdv) {
            if (verified_key in gradingFormResponses.sdv) {
              const check_sdv = gradingFormResponses.sdv[verified_key];
              const sdv_comments = gradingFormResponses.sdv[comments_key];
              this.appendSdvWithQuestionTitles(
                component,
                check_sdv,
                sdv_comments,
              );
            }
          }
          if (
            gradingFormResponses &&
            gradingFormResponses.files &&
            questionKey in gradingFormResponses.files
          ) {
            const imageUrls = gradingFormResponses.files[questionKey];
            this.appendImageWithQuestion(component, imageUrls, imagesArray);
          }
        }
      });
    };
    // Call the function with your data
    Formio.createForm(
      this.gradingFormElem,
      "https://examples.form.io/example",
    ).then((form) => {
      this.previousVisitValidationModule = new PreviousVisitValidationModule({
        gradingForm: this.gradingForm,
        gradingFormSchema: this.gradingFormSchema,
        getLabelFromSchema: (schema, key, val) =>
          this.getLabelFromSchema(schema, key, val),
        previousVisitGradingUrl: this.previousVisitGradingUrl,
        initialOverrides:
          this.gradingFormResponses.previous_visit_overrides || {},
      });
      this.gradingForm.on("render", () => {
        if (Object.keys(this.gradingFormResponses).length > 0) {
          displayImagesForQuestions(
            this.gradingForm.components,
            this.gradingFormResponses,
            this.data.get("attachments"),
          );
        }
        if (shouldProcessIGMP) {
          this.autoFillFromIGMP();
        }
        this.previousVisitValidationModule.attachPreviousVisitConsistencyOnBlur();
      });
      // uncomment the line below to rerender
      this.gradingForm.redraw();
      if (this.gradingForm.disabled) {
        const dropzoneElements = document.getElementsByClassName("dropzone");
        for (const element of dropzoneElements) {
          element.classList.add("hidden");
        }
      }
      this.gradingForm.on("change", (changed) => {
        this.handleReasonForChange(changed);
        if (this.previousVisitValidationModule) {
          this.previousVisitValidationModule.handleFormChange(changed);
        }
      });
      this.previousVisitValidationModule.fetchPreviousVisitGradingData();
    });
    await this.checkifAllImagesUploaded();
    // Initialize shared modules
    this.baseFile = new BaseFileModule(this.element);
    this.formState = new FormStateModule(
      this.gradingForm,
      this.formTarget,
      this.hasSubmitTarget ? this.submitTarget : null,
      this.hasUpdateTarget ? this.updateTarget : null,
    );
    this.notifications = new NotificationModule(
      this.hasLoadingImageTarget ? this.loadingImageTarget : null,
    );
    this.fileProcessingModule = new FileProcessingModule({
      notifications: this.notifications,
      visitDate: this.data.get("visitDate"),
      subjectCode: this.data.get("subjectCode"),
      studyName: this.data.get("studyName"),
      sdarUrl: this.data.get("sdarApi"),
      getPreviousVisitValidationModule: () =>
        this.previousVisitValidationModule,
    });
    this.formSubmissionModule = new FormSubmissionModule({
      formSaveUrl:
        document.location.origin + this.data.get("formUpdatePath") + ".json",
      formVersionId: this.data.get("versionId"),
      formUserId: this.data.get("userId"),
      formStackId: this.data.has("stackId") ? this.data.get("stackId") : null,
      notifications: this.notifications,
      stackIsFinalUrl: "",
      images: this.gradingImages,
      controller: this,
    });
    this.cornerstoneGradingModule = new CornerstoneGradingModule({
      formSaveUrl:
        document.location.origin + this.data.get("updatePath") + ".json",
      formUserId: this.data.get("userId"),
      formStackId: this.data.has("stackId") ? this.data.get("stackId") : null,
      annotation: this.annotation,
      ellipseData: this.ellipseData,
      element: this.viewerTarget,
      imageTag: this.imageTagTarget,
      url: this.url,
      probCount: this.data.get("countAnnotation"),
      method: this.data.get("mode") == "update" ? "PATCH" : "POST",
      gradingForm: this.gradingForm,
      releaseEye: this.releaseEye,
      notifications: this.notifications,
      IOLDiameter: this.data.get("iolDiameter"),
      minPoints: this.data.get("minPoints"),
      iolGradingService: this.data.get("iolGradingService"),
      controller: this, // Pass the controller instance
      gradingExistUrl: document.location.origin + this.data.get("existPath"),
    });
    this.RFCModule = new RFCModule({
      qcForm: this.gradingForm, // renamed here
      controller: this,
      status: this.data.get("status"),
    });
    this.RFCModule.handleStatusChange(
      this.gradingForm,
      this.data.get("responses"),
    );

    const auditHistoryPath = this.data.get("auditHistoryUrl");
    if (this.hasAuditHistoryTarget) {
      this.formAuditHistoryModule = new FormAuditHistoryModule({
        form: this.gradingForm,
        formSchema: this.gradingFormSchema,
        auditHistoryUrl: buildAuditHistoryJsonUrl(auditHistoryPath),
        auditHistoryTarget: this.auditHistoryTarget,
        changeSummaryTarget: this.hasChangeSummaryTarget
          ? this.changeSummaryTarget
          : null,
        stackStatus: this.data.get("status"),
      });

      this.formAuditHistoryModule.load();
      this.gradingForm.on("render", () => {
        this.formAuditHistoryModule?.attachQuestionHistoryIcons();
      });
    }

    this.printFormModule = new PrintFormModule({
      controller: this,
      formSchema: this.gradingFormSchema,
      originalFormSchema: this.originalGradingFormSchema, // Pass original unfiltered schema
      formResponses: this.gradingFormResponses,
      stackId: this.gradingFormStackId,
      studyId: this.data.get("studyId"),
      dataSourceKey: "grading_details",
      endpointPath: "grading_forms/get_grading_form_details",
      formTitle: "GRADING FORM",
      showModalityTitle: true,
      printFormWithData: (() => {
        const value = this.data.get("printFormWithData");
        return (
          value === "true" || value === true || value === "1" || value === 1
        );
      })(),
      includeAuditSummaryInPdf: (() => {
        const value = this.data.get("includeAuditSummaryInPdf");
        return (
          value === "true" || value === true || value === "1" || value === 1
        );
      })(),
      includeChangeSummaryInPdf: (() => {
        const value = this.data.get("includeChangeSummaryInPdf");
        return (
          value === "true" || value === true || value === "1" || value === 1
        );
      })(),
      odOsOrderPreference: (() => {
        const value = this.data.get("odOsOrderPreference");
        return (
          value === "true" || value === true || value === "1" || value === 1
        );
      })(),
      // All callbacks are optional now - module provides defaults
      // Using defaults for: renderField, isReasonForChange, shouldHideReasonImagesUngradable,
      // shouldSkipReasonImagesUngradable, extractAnswerValue
      auditHistoryUrl: buildAuditHistoryJsonUrl(auditHistoryPath),
      stackStatus: this.data.get("status"),
    });
    // Set the form in modules
    this.notifications.hideLoader();
    this.baseFile.setForm(this.gradingForm);

    // Add grader initials to thumbnails
    await this.addGraderInitialsToThumbnails();

    const processButton = document.getElementById("processBtn");
    const saveBtn = document.getElementById("saveBtn");
    const isViewOnly =
      new URLSearchParams(window.location.search).get("page_type") ===
      "view_only";

    if (isViewOnly || this.gradingFormAgreementElem?.checked) {
      this.formState.disableForm();
      if (processButton) {
        processButton.classList.add("hidden");
      }
      if (saveBtn) {
        saveBtn.classList.add("hidden");
      }
    } else {
      this.formState.enableForm();
      if (processButton) {
        processButton.classList.remove("hidden");
      }
      if (saveBtn) {
        saveBtn.classList.remove("hidden");
      }
    }

    window.addEventListener("successFileUpload", (event) => {
      const dataType = event.detail?.dataType;
      if (dataType !== "SDV") {
        return; // Ignore if data-type is not SDV
      }
      this.fileProcessingModule.handleGlobalFileUpload(
        this.gradingFormElem,
        event,
      );
    });
    // if we remove file from dropzone
    window.addEventListener("removeFile", (event) => {
      const dataType = event.detail?.dataType;
      if (dataType !== "SDV") {
        return; // Ignore if data-type is not SDV
      }

      this.fileProcessingModule.handleGlobalFileDelete(
        this.gradingFormElem,
        event,
      );
    });
  }

  autoFillFromIGMP() {
    const rawData = this.data.get("igmpAutograderApiData");

    if (!rawData) {
      console.warn("IGMP API data is missing.");
      return;
    }

    let apiData;

    try {
      apiData = JSON.parse(rawData);
    } catch (error) {
      console.error("Invalid IGMP JSON:", error);
      return;
    }

    if (!apiData?.data) {
      console.warn("IGMP API response data is empty.");
      return;
    }

    const resolveMappedValue = (path) => {
      let value = this.getDynamicValue(apiData.data, path);
      if (
        value === undefined ||
        value === null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0)
      ) {
        return 9999;
      }
      return value;
    };

    // IGMP prefill only: set Form.io value without going through
    // notifyAppendedFieldValue / afterProgrammaticValueSet. Those helpers are
    // for SDAR/manual append and can clear values via synthetic focusout.
    // Longitudinal consistency is unchanged for real user blur/change.
    const applyIgmpValue = (component, path, value) => {
      if (!component || typeof component.setValue !== "function") return;

      // Plain setValue so the input UI updates. Do not call
      // notifyAppendedFieldValue (that triggers synthetic focusout / clears).
      // User blur/change still runs longitudinal as before.
      component.setValue(value);

      if (path === "OD.reliabilityOfTest" || path === "OS.reliabilityOfTest") {
        setTimeout(() => {
          const label =
            document.querySelector(`label[for="${component.id}"]`) ||
            component.element?.querySelector("label");

          if (label && !label.querySelector(".ai-generated-badge")) {
            label.insertAdjacentHTML(
              "beforeend",
              ` <span class="badge bg-warning  ai-generated-badge"
                  title="Needs to be verified manually">
              AI predicted (${value})
            </span>`,
            );
          }
        }, 0);
      }
    };

    let filledCount = 0;

    if (
      this.gradingForm &&
      typeof this.gradingForm.everyComponent === "function"
    ) {
      this.gradingForm.everyComponent((component) => {
        try {
          const attrs =
            component?.component?.attributes || component?.attributes || {};
          const path = attrs["data-api-map"] || attrs["dataApiMap"];
          if (!path) return;

          applyIgmpValue(component, path, resolveMappedValue(path));
          filledCount += 1;
        } catch (error) {
          console.error(
            "Error filling IGMP-mapped component:",
            component,
            error,
          );
        }
      });
    }

    if (filledCount > 0) return;

    const fields = document.querySelectorAll("[data-api-map]");

    if (!fields.length) {
      console.warn("No fields found with data-api-map.");
      return;
    }

    fields.forEach((field) => {
      try {
        const path = field.getAttribute("data-api-map");

        if (!path) {
          console.warn("Missing data-api-map attribute.");
          return;
        }

        const value = resolveMappedValue(path);
        const rawName = field.getAttribute("name");
        const key = rawName
          ? rawName.replace(/^data\[/, "").replace(/\]$/, "")
          : null;

        if (key) {
          const component = this.gradingForm.getComponent(key);
          if (component) {
            applyIgmpValue(component, path, value);
            return;
          }
        }

        field.value = value;
      } catch (error) {
        console.error("Error filling field:", field, error);
        field.value = 9999;
      }
    });
  }

  getDynamicValue(data, path) {
    try {
      if (!data || !path) return 9999;

      const parts = String(path)
        .trim()
        .split(".")
        .map((part) => part.trim())
        .filter(Boolean);
      let current = data;

      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];

        // Normal object property
        if (
          current &&
          typeof current === "object" &&
          !Array.isArray(current) &&
          current[part] !== undefined &&
          current[part] !== null
        ) {
          current = current[part];
          continue;
        }

        // If current is array (e.g. averageSensitivityPerColor.001.numerosity)
        if (Array.isArray(current)) {
          current = current.find((item) => {
            if (Array.isArray(item.color)) {
              const compact = item.color.join("");
              const csv = item.color.join(",");
              return compact === part || csv === part;
            }

            return (
              String(item.id) === part ||
              String(item.code) === part ||
              String(item.value) === part
            );
          });

          if (!current) return 9999;
          continue;
        }

        return 9999;
      }

      return current === undefined || current === null || current === ""
        ? 9999
        : current;
    } catch (error) {
      console.error("Error in getDynamicValue:", error);
      return 9999;
    }
  }

  handleReasonForChange(form) {
    if (this.data.get("status") === "editing") {
      console.log(this.data.get("status"), "handleReasonForChange");
      this.RFCModule.handleReasonForChange(form);
    }
  }

  checkifAllImagesUploaded() {
    this.gradingForm.on("change", () => {
      const qcImagesElements = document.querySelectorAll(".qc_images");
      this.dataQuestionArray = Array.from(qcImagesElements).map((element) =>
        element.getAttribute("data-question"),
      );
    });
  }

  calculateAngle() {
    this.cornerstoneGradingModule.calculateAngle(
      this.apiUrl,
      this.data.get("apiKey"),
    );
  }

  appendSdvWithQuestionTitles(component, check_sdv, sdv_comments) {
    if (check_sdv === "true") {
      // Create a span element for the SVG icon with the tooltip
      const svgDive = document.createElement("span");
      svgDive.classList.add("has-tooltip");
      svgDive.innerHTML = `
          <?xml version="1.0" encoding="iso-8859-1"?>
            <!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
            <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
            <svg fill="#007BFF" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="16px" height="16px" viewBox="0 0 509.604 509.604"
                xml:space="preserve" style ="margin-top:3px">
                <g>
                    <g>
                        <path d="M34.262,333.282c8.119,6.75,14.793,15.223,14.143,20.988c-0.382,3.443-0.593,6.943-0.593,10.5
                            c0,52.393,41.3,94.861,92.24,94.861c6.292,0,12.431-0.65,18.37-1.885c10.002-2.074,21.812,1.941,28.888,9.793
                            c16.82,18.646,40.803,30.342,67.492,30.342c28.19,0,53.426-13.016,70.342-33.518c6.723-8.146,18.103-11.533,28.22-8.5
                            c8.166,2.447,16.811,3.768,25.751,3.768c50.939,0,92.24-42.477,92.24-94.861c0-5.861-0.535-11.59-1.549-17.145
                            c-1.712-9.371,2.85-21.047,10.471-28.363c18.025-17.289,29.328-41.883,29.328-69.242c0-29.787-13.368-56.323-34.263-73.698
                            c-8.118-6.751-14.793-15.224-14.143-20.99c0.383-3.442,0.593-6.942,0.593-10.5c0-52.393-41.301-94.86-92.24-94.86
                            c-6.292,0-12.431,0.65-18.369,1.884c-10.002,2.075-21.812-1.941-28.889-9.792c-16.82-18.647-40.803-30.342-67.492-30.342
                            c-26.688,0-50.671,11.695-67.492,30.342c-7.076,7.841-18.886,11.867-28.888,9.792c-5.938-1.234-12.078-1.884-18.37-1.884
                            c-50.939,0-92.24,42.477-92.24,94.86c0,5.049,0.392,10.002,1.147,14.832c1.262,8.128-4.447,18.149-12.747,24.681
                            C14.219,201.663,0,228.887,0,259.583C0,289.37,13.368,315.907,34.262,333.282z M131.475,263.016
                            c2.046-3.625,7.268-3.672,12.049,0.479l48.119,33.918c2.61,1.588,5.106,2.4,7.506,2.4c4.963,0,8.893-3.576,12.689-7.02
                            l153.985-154.138c9.629-10.471,18.99-14.162,25.102-10.146c2.82,1.855,4.646,4.647,5.135,7.87
                            c0.583,3.825-0.756,7.946-3.768,11.599l-185.149,224.91c-2.687,3.26-6.11,5.059-9.629,5.059c-4.179,0-7.965-2.516-10.404-6.895
                            l-54.344-97.969C130.519,269.422,130.021,265.618,131.475,263.016z"/>
                    </g>
                </g>
            </svg>     
            <span class="tooltip bottom-2 w-min">${sdv_comments}</span>
          `;
      // Get the label element within component.element
      const labelElement = component.element.querySelector("label");
      labelElement.classList.add("flex", "gap-2");
      // Concatenate component.label and svgDive and set it as the innerHTML of labelElement
      labelElement.innerHTML = component.label + svgDive.outerHTML;
      // Optionally, you can also console.log the updated label
      console.log(labelElement.innerHTML);
    }
  }

  appendImageWithQuestion(component, fileUrls, filesArray) {
    const addedFiles = new Set();
    const container = document.createElement("div");
    container.classList.add("flex", "mt-1");

    const commonAttributes = {
      width: "100",
      height: "100",
      alt: "Attachment Image",
      style: "cursor: pointer;",
    };

    for (const fileUrl of fileUrls) {
      for (let i = 0; i < filesArray.length; i++) {
        const attachment = filesArray[i].split("<!==!>");
        let fileName = "";
        if (attachment[1]) {
          // Check if attachment[1] exists
          fileName = attachment[1].split("/").pop();
        } else {
          return;
        }
        const decodedFileName = decodeURIComponent(fileName);

        if (fileUrl === decodedFileName && !addedFiles.has(decodedFileName)) {
          const fileExtension = fileName.split(".").pop().toLowerCase();
          const deleteIcon = this.createDeleteIcon(
            decodedFileName,
            component.key,
            attachment[1],
            attachment[0],
            this.gradingForm._disabled,
          );

          if (fileExtension === "pdf") {
            const pdfIconElement = document.createElement("img");
            this.setAttributes(pdfIconElement, {
              src: this.pdfIcon,
              ...commonAttributes,
            });
            const pdfLink = document.createElement("a");
            this.setAttributes(pdfLink, {
              href: attachment[1],
              target: "_blank",
            });
            pdfLink.appendChild(pdfIconElement);
            const fileContainer = document.createElement("div");
            fileContainer.classList.add("file-container");
            fileContainer.appendChild(pdfLink);
            fileContainer.appendChild(deleteIcon);
            container.appendChild(fileContainer);
          } else {
            const imageElement = document.createElement("img");
            this.setAttributes(imageElement, {
              src: attachment[1],
              ...commonAttributes,
            });

            const imageContainer = document.createElement("div");
            imageContainer.classList.add("image-container");
            imageContainer.appendChild(imageElement);
            imageContainer.appendChild(deleteIcon);

            imageElement.addEventListener("click", function () {
              const lightboxImage = document.getElementById("lightbox-image");
              lightboxImage.src = attachment[1];
              const lightboxContainer =
                document.getElementById("lightbox-container");
              lightboxContainer.style.display = "block";
            });

            const lightboxContainer =
              document.getElementById("lightbox-container");
            lightboxContainer.addEventListener("click", function () {
              lightboxContainer.style.display = "none";
            });

            container.appendChild(imageContainer);
          }
          addedFiles.add(decodedFileName);
        }
      }
    }

    if (container.innerHTML.trim() !== "") {
      component.element.appendChild(container);
    }
  }

  // create delete icon to show that with the SDV files or screenshots
  createDeleteIcon(
    decodedFileName,
    componentKey,
    attachmentUrl,
    attachmentId,
    gradingFormDisabled,
  ) {
    const deleteIcon = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg",
    );
    const attributes = {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      "data-action": "click->cornerstone-grade#deleteSDVImage",
      "data-filename": decodedFileName,
      "data-key": componentKey,
      "data-url": attachmentUrl,
      "data-id": attachmentId,
    };

    this.setAttributes(deleteIcon, attributes);

    if (!gradingFormDisabled) {
      deleteIcon.innerHTML = `
                <title>Delete Attachment</title>
                <path fill="#FF0000" d="M18 4h-4.18l-1.82-2H10L8.82 4H4v2h16V4zM6.36 8h11.28l1.23 10.96l.01.04V20H4v-1.96l.01-.04L5.64 8zM8 18h8v-2H8v2zm0-4h8v-6H8v6z"/>
            `;
    }

    return deleteIcon;
  }
  // To delete the images with Questions for SDV (Source documents verifications)
  deleteSDVImage(e) {
    e.preventDefault();
    const parentDiv = e.target.closest(".image-container, .file-container");
    const confirmation = confirm("Are you sure you want to delete this file?");
    if (confirmation) {
      const fileName = e.currentTarget.getAttribute("data-filename");
      const fileKey = e.currentTarget.getAttribute("data-key");
      const fileUrl = e.currentTarget.getAttribute("data-url");
      const blob_id = e.currentTarget.getAttribute("data-id");
      fetch(`/delete_image`, {
        method: "post",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-CSRF-Token": document.head
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content"),
        },
        body: JSON.stringify({
          image_url: fileName,
          stack_id: this.gradingFormStackId,
          image_array: fileKey,
          url: fileUrl,
          blob_id: blob_id,
        }),
      })
        .then((response) => {
          if (response.ok) {
            parentDiv.remove();
            location.reload();
          } else {
            console.error("Failed to delete image");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }

  // set attribute of icon
  setAttributes(element, attributes) {
    Object.entries(attributes).forEach(([key, value]) =>
      element.setAttribute(key, value),
    );
  }

  toggleTags(e) {
    this.imageTag.classList.toggle("hidden");
    e.preventDefault();
  }

  get url() {
    return this.data.get("url");
  }

  set url(value) {
    this.data.set("url", value);
  }

  // formio functions
  formSaveDraft(e, skipValidation = false) {
    return this.handleFormCommitAndSubmit(
      e,
      "initiated",
      true,
      true,
      skipValidation,
    );
  }

  async checkIfGradingFormExists() {
    const response = await fetch(this.gradingFormExistUrl);
    return await response.json();
  }

  formCommit(e) {
    if (this.gradingFormAgreementElem?.checked) {
      this.handleFormCommitAndSubmit(e, "completed", true);
    } else {
      alert("You must agree to terms");
    }
    e.preventDefault();
  }

  formUpdate(e) {
    this.handleFormCommitAndSubmit(e, "editing");
  }

  handleFormCommitAndSubmit(
    e,
    status,
    shouldSubmit = false,
    draftStatus = false,
    skipValidation = false,
  ) {
    e.preventDefault();

    // If skipValidation is true, bypass form validation and use current form data
    if (skipValidation) {
      // Collect all current form values from all components without validation
      const currentData = {};
      this.gradingForm.everyComponent((component) => {
        if (component.component && component.component.key) {
          try {
            const value = component.getValue();
            if (value !== undefined && value !== null && value !== "") {
              currentData[component.component.key] = value;
            } else if (value === "" || value === null) {
              // Include empty values too to ensure we save all form state
              currentData[component.component.key] = value;
            }
          } catch (error) {
            // If getValue fails, try to get from component data
            if (component.data && component.data.value !== undefined) {
              currentData[component.component.key] = component.data.value;
            }
          }
        }
      });

      // Merge with existing submission to preserve metadata
      const existingSubmission = this.gradingForm.submission || {};

      // Construct submission object with all current form data
      const submission = {
        data: {
          ...existingSubmission.data,
          ...currentData, // Current form values override existing ones
        },
        isAgreed: existingSubmission.isAgreed || false,
        ...existingSubmission,
      };
      submission.previous_visit_overrides = this.previousVisitValidationModule
        ? this.previousVisitValidationModule.getOverrides()
        : {};

      // Collect images
      this.formSubmissionModule.collectImagesFromSelector(
        ".attached_images",
        this.gradingImages,
      );

      // Note: We don't call defaultSaveAnnotation here when skipValidation is true
      // because the calling method (submitGrading in cornerstone_grading_module.js)
      // will handle saving annotations and ellipse data separately via saveGrading()

      // Submit the form without validation - saves all current data to database
      return PreviousVisitValidationModule.confirmLongitudinalReportBeforeSubmit(
        this.gradingFormSchema,
        submission.previous_visit_overrides,
        (schema, k, v) => this.getLabelFromSchema(schema, k, v),
        status,
      ).then((shouldProceed) => {
        if (!shouldProceed) return;
        return this.formSubmissionModule.submitForm(
          submission,
          this.data.get("mode") == "update" ? "PATCH" : "POST",
          null,
          null,
          draftStatus,
          "grading_form",
          status,
        );
      });
    }

    // Validate the form before submission
    this.gradingForm
      .submit()
      .then((submission) => {
        // Check if images are uploaded!
        if (status == "completed") {
          const uploaded = this.formSubmissionModule.checkIfAllImagesUploaded(
            submission,
            this.dataQuestionArray,
          );

          if (!uploaded) {
            // Reject the promise to prevent further execution
            this.notifications.error("Images not uploaded");
            return;
          }
        }
        // Assuming you have this.gradingImages defined in your controller
        this.formSubmissionModule.collectImagesFromSelector(
          ".attached_images",
          this.gradingImages,
        );
        this.defaultSaveAnnotation(e);
        submission.previous_visit_overrides = this.previousVisitValidationModule
          ? this.previousVisitValidationModule.getOverrides()
          : {};
        // Handle the form submission after commit is successful
        return PreviousVisitValidationModule.confirmLongitudinalReportBeforeSubmit(
          this.gradingFormSchema,
          submission.previous_visit_overrides,
          (schema, k, v) => this.getLabelFromSchema(schema, k, v),
          status,
        ).then((shouldProceed) => {
          if (!shouldProceed) return;
          return this.formSubmissionModule.submitForm(
            submission,
            this.data.get("mode") == "update" ? "PATCH" : "POST",
            null,
            null,
            draftStatus,
            "grading_form",
            status,
          );
        });
      })
      .catch((error) => {
        // Form.io often rejects with an array of validation errors.
        if (Array.isArray(error) && error.length > 0) {
          const messages = error
            .map((e) => e?.message || e?.messages?.join(", "))
            .filter(Boolean);
          const html = messages.length
            ? '<ul class="text-left">' +
              messages.map((m) => "<li>" + String(m) + "</li>").join("") +
              "</ul>"
            : "Please review required fields and validation rules before submitting.";
          Swal.fire({
            icon: "warning",
            title: "Form Validation Required",
            html: html,
            confirmButtonText: "OK",
          });
        } else {
          console.error(error);
          Swal.fire({
            icon: "error",
            title: "Submission Failed",
            text: "Something went wrong while submitting the form. Please try again.",
            confirmButtonText: "OK",
          });
        }
      });
  }

  // Save Annotations
  submitGrading(e) {
    e.preventDefault();
    // Call the submitGrading method from the grading module with the HTTP method
    const processButtons = document.getElementsByClassName("processButton");
    const processButton = processButtons[0]; // Get the first element with class "processButton"
    if (
      processButton &&
      processButton.classList &&
      processButton.classList.contains("bg-red-600")
    ) {
      processButton.classList.remove("bg-red-600");
      processButton.classList.add("bg-purple-800");
    }
    this.cornerstoneGradingModule.submitGrading(e);
  }

  defaultSaveAnnotation(e) {
    // Call defaultSaveAnnotation from the grading module
    this.cornerstoneGradingModule.defaultSaveAnnotation(e);
  }

  successAlert() {
    window.dispatchEvent(new CustomEvent("successAlert"));
  }

  errorAlert() {
    window.dispatchEvent(new CustomEvent("errorAlert"));
  }

  toggleSubmitArea() {
    var staticPanel = document.getElementById("expend_colapse");
    if (this.questionAreaTarget.classList.contains("hidden")) {
      this.questionAreaTarget.classList.remove("hidden");
      staticPanel.classList.add("fa-minus-square-o");
      staticPanel.classList.remove("fa-plus-square-o");
    } else {
      this.questionAreaTarget.classList.add("hidden");
      staticPanel.classList.add("fa-plus-square-o");
      staticPanel.classList.remove("fa-minus-square-o");
    }
  }

  nextImage(e) {
    const len = this.images.length;
    this.currentImage = Math.abs((this.currentImage + 1) % len);
    this.changeImage(null, this.images[this.currentImage].elem);
    e.preventDefault();
  }

  previousImage(e) {
    const len = this.images.length;
    this.currentImage = Math.abs(this.currentImage + len - 1) % len;
    this.changeImage(null, this.images[this.currentImage].elem);
    e.preventDefault();
  }

  fetchPreviousVisitAnswers(event) {
    event.preventDefault();
    const method = "POST";
    fetch(this.gradingPreviousUrl, {
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.head
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
      },
      method: method,
      body: JSON.stringify({
        stack_id: this.gradingFormStackId,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.message == "Found") {
          if (!data || typeof data !== "object") {
            throw new Error("Invalid JSON data received");
          }
          const previousGradingFormData = data.responses.concat(
            data.history_reponse,
          );
          const userIDs = data.user_names;
          const previousVisitLabel = data.previous_visit_label;
          const previousVisitDate = data.previous_date;
          const formStatuses = data.status;
          const visitDates = data.history_visit_dates;
          const visitIds = data.history_visits_ids;
          const previousStatusArray = Array.isArray(data.previous_status)
            ? data.previous_status
            : [];
          if (data.responses.length !== userIDs.length) {
            console.error(
              "Length mismatch between previousGradingFormData and userIDs",
            );
          } else {
            if (previousGradingFormData.length > 0) {
              const firstPreviousStatus =
                previousStatusArray.length > 0 ? previousStatusArray[0] : null;
              this.appendPreviousVisitAnsToGradingForm(
                previousGradingFormData[0],
                firstPreviousStatus,
                previousVisitLabel,
                previousVisitDate,
              );
            }

            for (let i = 1; i < previousGradingFormData.length; i++) {
              const visitDate =
                visitDates.length > i - 1 ? visitDates[i - 1] : null;
              const visitId = visitIds.length > i - 1 ? visitIds[i - 1] : null;
              const formStatus =
                formStatuses.length > i - 1 ? formStatuses[i - 1] : null;
              this.appendPreviousVisitAnsToGradingForm(
                previousGradingFormData[i],
                null,
                previousVisitLabel,
                previousVisitDate,
                formStatus,
                visitDate,
                visitId,
                true,
              );
            }
          }

          document
            .getElementById("viewPreviousAnsButton")
            .classList.add("hidden");
          document
            .getElementById("hidePreviousAnsButton")
            .classList.remove("hidden");
        } else if (data.message == "No previous visit Found") {
          alert("No previous visit Available");
        }
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }

  hidePreviousAns(event) {
    event.preventDefault();

    // Remove the appended data by removing the .grader-answers-div elements
    const graderAnswersDivs = document.querySelectorAll(".adj-answers-div");
    graderAnswersDivs.forEach((div) => {
      div.remove();
    });

    // Show the "View Previous Ans" button
    const viewPreviousAnsButton = document.getElementById(
      "viewPreviousAnsButton",
    );
    viewPreviousAnsButton.classList.remove("hidden");

    // Hide the "Hide Previous Ans" button
    const hidePreviousAnsButton = document.getElementById(
      "hidePreviousAnsButton",
    );
    hidePreviousAnsButton.classList.add("hidden");
  }

  showLongitudinalChangesReport(event) {
    if (event && typeof event.preventDefault === "function") {
      event.preventDefault();
    }

    const overrides =
      (this.gradingFormResponses &&
        this.gradingFormResponses.previous_visit_overrides) ||
      {};
    PreviousVisitValidationModule.openLongitudinalChangesReportModal(
      this.gradingFormSchema,
      overrides,
      (schema, questionKey, val) =>
        this.getLabelFromSchema(schema, questionKey, val),
    );
  }

  appendPreviousVisitAnsToGradingForm(
    previousGradingFormData,
    previousStatus,
    previousVisitLabel,
    previousVisitDate,
    formStatus,
    visitDate,
    visitId,
    isSubsequentCall = false,
  ) {
    FormioUtils.eachComponent(this.gradingForm.components, (c) => {
      if (
        c &&
        c.component &&
        c.element &&
        !c.element.classList.contains("formio-hidden")
      ) {
        let graderAnswersDiv = c.element.querySelector(".adj-answers-div");
        if (!graderAnswersDiv) {
          graderAnswersDiv = document.createElement("div");
          graderAnswersDiv.classList.add("adj-answers-div");
          c.element.appendChild(graderAnswersDiv);
        }

        const questionKey = c.component.key;

        if (previousGradingFormData.data.hasOwnProperty(questionKey)) {
          const label =
            this.getLabelFromSchema(
              this.gradingFormSchema,
              questionKey,
              previousGradingFormData.data[questionKey],
            ) || "nil";
          const timestamp = new Date(previousVisitDate);
          const formattedDate = `${timestamp.getFullYear()}-${String(
            timestamp.getMonth() + 1,
          ).padStart(2, "0")}-${String(timestamp.getDate()).padStart(2, "0")}`;
          let currentFormStatus = formStatus;
          if (currentFormStatus === "completed") {
            currentFormStatus = "[a]";
          } else if (currentFormStatus === "editing") {
            currentFormStatus = "[e]";
          } else {
            currentFormStatus = "[p]";
          }
          let previousFormStatus = previousStatus;
          if (previousFormStatus === "completed") {
            previousFormStatus = "[a]";
          } else if (previousFormStatus === "editing") {
            previousFormStatus = "[e]";
          } else {
            previousFormStatus = "[p]";
          }
          const answerTextSpan = document.createElement("span");
          answerTextSpan.classList.add("has-tooltip");
          answerTextSpan.innerHTML = !isSubsequentCall
            ? `
                        ${previousVisitLabel}: ${label} (${formattedDate}) ${previousFormStatus}
                    `
            : "";

          if (!isSubsequentCall) {
            // Append the answerTextSpan to graderAnswersDiv
            graderAnswersDiv.appendChild(answerTextSpan);

            // Add the 'has-tooltip' class to the answerTextSpan
            answerTextSpan.classList.add("has-tooltip");

            // Create the tooltip span
            const tooltipSpan = document.createElement("span");
            tooltipSpan.classList.add("tooltip");

            // Append the tooltip span to the answerTextSpan
            answerTextSpan.appendChild(tooltipSpan);
          } else {
            // Find the first element with the class 'has-tooltip'
            const firstAnswerSpan =
              graderAnswersDiv.querySelector(".has-tooltip");

            if (firstAnswerSpan) {
              const tooltipSpan = firstAnswerSpan.querySelector(".tooltip");

              if (tooltipSpan) {
                // Safely append new content to the tooltip
                tooltipSpan.innerHTML += `${visitId}: ${label} (${visitDate}) ${currentFormStatus}<br>`;
              } else {
                console.error("Tooltip span not found inside has-tooltip span");
              }
            } else {
              // Optional: Create a new span if not found
              const newAnswerSpan = document.createElement("span");
              newAnswerSpan.classList.add("has-tooltip");
              graderAnswersDiv.appendChild(newAnswerSpan);

              const newTooltipSpan = document.createElement("span");
              newTooltipSpan.classList.add("tooltip");
              newAnswerSpan.appendChild(newTooltipSpan);
              // Now update the new tooltip span with the content
              newTooltipSpan.innerHTML += `${visitId}: ${label} (${visitDate}) ${currentFormStatus}<br>`;
            }
          }
        }
      }
    });
  }

  getLabelFromSchema(schema, questionKey, questionValue) {
    for (const component of schema.components) {
      if (component.components) {
        // If the component has nested questions, iterate through them
        for (const question of component.components) {
          const targetKey = question["key"];
          const checkboxes = [];
          if (
            question.values &&
            question["type"] === "radio" &&
            targetKey === questionKey
          ) {
            for (const item of question.values) {
              if (item["value"] == questionValue) {
                return item["label"];
              }
            }
          } else if (
            question.values &&
            question["type"] === "selectboxes" &&
            targetKey === questionKey
          ) {
            for (var key in questionValue) {
              if (questionValue[key]) {
                // Use the current key to access the corresponding element in question.values
                checkboxes.push(question.values[key - 1]["label"]);
              }
            }
            return checkboxes;
          }
        }
      }
    }
    return questionValue;
  }

  arrowAnnotationTool(e) {
    this.cornerstoneGradingModule.activateTool("ArrowAnnotateTool");
    e.preventDefault();
  }

  readImages() {
    const images = document.querySelectorAll(".image");
    images.forEach((i) => {
      this.images.push({
        id: i.getAttribute("data-id"),
        url: i.getAttribute("data-url"),
        elem: i,
      });
    });
  }

  // Getter and Setter for `url`
  get url() {
    return this.data.get("url");
  }

  set url(value) {
    this.data.set("url", value);
  }

  // Updated `changeImage` method
  changeImage(e, elem) {
    let target = e ? e.target : elem;
    let imageUrl = target.dataset.url;

    this.cornerstoneGradingModule.imageLoader(imageUrl);

    if (e) {
      this.currentImage = target.dataset.idx;
    }

    this.imageTag.innerHTML = "";

    // remove all active borders
    const allImageBoxes = document.querySelectorAll(".image-box");
    allImageBoxes.forEach((i) => i.classList.remove("border-primary-500"));
    // active border around current image
    target.parentNode.classList.add("border-primary-500");

    // Update the data-cornerstone-grade-url attribute
    const gradeUrlElem = document.querySelector("[data-cornerstone-grade-url]");
    if (gradeUrlElem) {
      gradeUrlElem.setAttribute("data-cornerstone-grade-url", imageUrl);
    }

    // Now we can update `this.url` directly
    this.url = imageUrl;
  }

  toggle() {
    this.toggleModule.buttonEnable();
  }

  screenshotTool(event) {
    event.preventDefault();

    const viewer = this.viewerTarget;

    html2canvas(viewer, {
      useCORS: true, // In case of cross-origin images
      backgroundColor: null, // Preserves transparency if needed
    })
      .then((canvas) => {
        const image = canvas.toDataURL("image/png");

        // Optional: Trigger download
        const link = document.createElement("a");
        link.href = image;
        link.download = `${this.filename}.png`;
        link.click();
      })
      .catch((error) => {
        console.error("Screenshot failed:", error);
      });
  }

  downloadAnnotation(event) {
    event.preventDefault();
    const annotations = this.annotation;
    const ellipseData = this.ellipseData;

    const imageUrl = document.location.origin + "/" + this.url;

    if (!imageUrl || typeof imageUrl !== "string" || imageUrl.trim() === "") {
      alert("Invalid image URL provided.");
      return;
    }

    const imageAnn = annotations[imageUrl];

    if (!imageAnn) {
      alert("No annotation data found for this image URL.");
      return;
    }

    const result = {
      IOL: [],
      Pupil: [],
      Cornea: [],
      IOL_diameter: this.data.get("iolDiameter"),
    };

    if (imageAnn?.IOLProbe?.data) {
      imageAnn.IOLProbe.data.forEach((m) => {
        if (m.handles?.end) {
          result.IOL.push([
            Math.round(m.handles.end.x),
            Math.round(m.handles.end.y),
          ]);
        }
      });
    }

    if (imageAnn?.PupilProbe?.data) {
      imageAnn.PupilProbe.data.forEach((m) => {
        if (m.handles?.end) {
          result.Pupil.push([
            Math.round(m.handles.end.x),
            Math.round(m.handles.end.y),
          ]);
        }
      });
    }

    if (imageAnn?.CorneaProbe?.data) {
      imageAnn.CorneaProbe.data.forEach((m) => {
        if (m.handles?.end) {
          result.Cornea.push([
            Math.round(m.handles.end.x),
            Math.round(m.handles.end.y),
          ]);
        }
      });
    }

    // Send data to Rails controller for CSV generation
    this.exportToTxtZip(result, ellipseData[this.url][0]);
  }

  async exportToTxtZip(inputData, outputData) {
    try {
      // Get CSRF token
      const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute("content");

      // Prepare form data
      const formData = new FormData();
      formData.append("input_data", JSON.stringify(inputData));
      formData.append("output_data", JSON.stringify(outputData));
      formData.append("filename", this.filename);

      // Make the request
      const response = await fetch(this.donwloadUrl, {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken,
          Accept: "application/zip",
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Get the ZIP content
      const zipBlob = await response.blob();

      // Create download link and trigger download
      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement("a");
      link.href = url;
      const now = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
      const randomDigits = Math.floor(100 + Math.random() * 900); // Generates a 3-digit random number
      link.download = `Input_output_${now}_${randomDigits}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      console.log("ZIP download completed successfully");
    } catch (error) {
      console.error("Error downloading ZIP:", error);
      alert("Failed to download ZIP. Please try again.");
    }
  }

  probeTool = (e) => {
    e.preventDefault();
    const probeType = e.currentTarget.dataset.probeType;

    // Activate the specific tool based on the probe type
    switch (probeType) {
      case "iol":
        this.cornerstoneGradingModule.activateTool("IOLProbe");
        break;
      case "pupil":
        this.cornerstoneGradingModule.activateTool("PupilProbe");
        break;
      case "cornea":
        this.cornerstoneGradingModule.activateTool("CorneaProbe");
        break;
      default:
        this.cornerstoneGradingModule.activateTool("Probe");
        break;
    }
  };

  toggleEllipseData(e) {
    e.preventDefault();
    this.cornerstoneGradingModule.toggleEllipseData(e);
  }

  levelsTool(e) {
    e.preventDefault();
    this.cornerstoneGradingModule.activateTool("Wwwc");
  }

  panTool(e) {
    e.preventDefault();
    this.cornerstoneGradingModule.activateTool("Pan");
  }

  lengthTool(e) {
    e.preventDefault();
    this.cornerstoneGradingModule.activateTool("Length");
  }

  angleTool(e) {
    e.preventDefault();
    this.cornerstoneGradingModule.activateTool("Angle");
  }

  rectangleTool(e) {
    e.preventDefault();
    this.cornerstoneGradingModule.activateTool("RectangleRoi");
  }

  freehandTool(e) {
    e.preventDefault();
    this.cornerstoneGradingModule.activateTool("FreehandRoi");
  }

  ellipseTool(e) {
    e.preventDefault();
    this.cornerstoneGradingModule.activateTool("EllipticalRoi");
  }

  eraserTool(e) {
    e.preventDefault();
    this.cornerstoneGradingModule.activateTool("Eraser");
  }

  labelTool(e) {
    this.cornerstoneGradingModule.labelTool(e);
  }

  printForm(event) {
    event.preventDefault();
    this.printFormModule.printForm();
  }

  // These methods are now handled by PrintFormModule defaults
  // Keeping them here only if needed for other purposes (not for print)

  getFormData(stackId) {
    const studyId = this.data.get("studyId");
    const url = `${document.location.origin}/studies/${studyId}/grading_forms/get_grading_form_details`;
    return fetch(url, {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "X-CSRF-Token": document.head
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
      },
      method: "POST",
      body: JSON.stringify({
        stack_id: stackId,
      }),
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.error || "Failed to fetch grading form data");
        }
        return data;
      })
      .catch((error) => {
        console.error("Error fetching grading form details:", error);
        throw error;
      });
  }

  // These methods are now handled by PrintFormModule defaults
  // Keeping them here only if needed for other purposes (not for print)

  // Get grader name from user ID
  getGraderName(userId) {
    return fetch(this.graderNameUrl, {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "X-CSRF-Token": document.head
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
      },
      method: "POST",
      body: JSON.stringify({
        user: {
          user_id: userId,
        },
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response.json().then((data) => data.full_name);
        } else {
          throw new Error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  // Get initials from full name
  getUserInitials(fullName) {
    if (!fullName) return "";
    const nameParts = fullName.trim().split(/\s+/);
    if (nameParts.length === 1) {
      return nameParts[0].substring(0, 2).toUpperCase();
    }
    return nameParts.map((part) => part[0].toUpperCase()).join("");
  }

  // Find the final annotated image for a user
  findFinalAnnotatedImage(userAnnotations, annotatedImageUrls) {
    let latestImageUrl = null;
    let latestTimestamp = 0;

    // Check each annotated image for timestamp at the image level
    for (const imageUrl of annotatedImageUrls) {
      const imageAnnotations = userAnnotations[imageUrl];

      // Check for image-level timestamp
      if (imageAnnotations && imageAnnotations._timestamp) {
        const timestamp = imageAnnotations._timestamp;

        if (timestamp > latestTimestamp) {
          latestTimestamp = timestamp;
          latestImageUrl = imageUrl;
        }
      }
    }

    return latestImageUrl;
  }

  // Add grader initials to image thumbnails
  async addGraderInitialsToThumbnails() {
    try {
      const imageBoxes = document.querySelectorAll(".image-box");

      // Get grading form status
      const gradingFormStatus = this.data.get("status");
      const isGradingCompleted =
        gradingFormStatus === "completed" ||
        this.gradingFormAgreementElem?.checked;

      // Get current user ID
      const currentUserId = this.gradingFormUserId;

      // If there are no annotations, exit early
      if (!this.annotation || Object.keys(this.annotation).length === 0) {
        return;
      }

      // Find the final image if grading is completed
      let finalImageUrl = null;
      if (isGradingCompleted && this.annotation) {
        const annotatedImageUrls = Object.keys(this.annotation);
        if (annotatedImageUrls.length > 0) {
          finalImageUrl = this.findFinalAnnotatedImage(
            this.annotation,
            annotatedImageUrls,
          );
        }
      }

      // Process each thumbnail
      for (const box of imageBoxes) {
        const img = box.querySelector(".image");
        if (!img) continue;

        // Construct imageUrl
        const imageUrl = document.location.origin + "/" + img.dataset.url;

        // Extract filename from URL for matching (ActiveStorage URLs have changing tokens)
        const getFilename = (url) => {
          const parts = url.split("/");
          return parts[parts.length - 1]; // Get last part (filename)
        };

        const currentFilename = getFilename(imageUrl);

        // Remove existing labels if any
        const existingText = box.querySelector(".processed-by-text");
        if (existingText) {
          existingText.remove();
        }

        // Check if this image has annotations
        // Match by filename since ActiveStorage tokens change
        let annotationData = null;
        let matchedAnnotationUrl = null;

        if (this.annotation) {
          // Try exact match first
          if (this.annotation[imageUrl]) {
            annotationData = this.annotation[imageUrl];
            matchedAnnotationUrl = imageUrl;
          } else {
            // Try finding a match by filename
            for (const annotationUrl in this.annotation) {
              const annotationFilename = getFilename(annotationUrl);

              if (annotationFilename === currentFilename) {
                annotationData = this.annotation[annotationUrl];
                matchedAnnotationUrl = annotationUrl;
                break;
              }
            }
          }
        }

        if (annotationData) {
          const fullName = await this.getGraderName(currentUserId);
          const initials = this.getUserInitials(fullName);

          // Check if this is the final image for submitted grading
          // Match by filename since ActiveStorage tokens change
          const finalImageFilename = finalImageUrl
            ? getFilename(finalImageUrl)
            : null;
          const isFinalImage =
            isGradingCompleted && finalImageFilename === currentFilename;

          if (isFinalImage) {
            const labelContainer = document.createElement("div");
            labelContainer.className = "processed-by-text";
            labelContainer.style.fontSize = "8px";
            labelContainer.style.color = "#6B7280";
            labelContainer.style.marginTop = "3px";
            labelContainer.style.textAlign = "center";
            labelContainer.style.lineHeight = "1.3";

            const link = document.createElement("a");
            link.href = "#";
            link.textContent = `Graded by: ${initials}`;
            link.style.color = "#2563EB";
            link.style.textDecoration = "underline";
            link.style.cursor = "pointer";

            // Add click handler to download image
            link.addEventListener("click", async (e) => {
              e.preventDefault();
              try {
                const response = await fetch(imageUrl);
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const downloadLink = document.createElement("a");
                downloadLink.href = url;

                // Extract filename from URL
                const filename =
                  imageUrl.split("/").pop().split("?")[0] || "image.png";
                downloadLink.download = filename;

                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                window.URL.revokeObjectURL(url);
              } catch (error) {
                console.error("Error downloading image:", error);
                // Fallback: open in new tab
                window.open(imageUrl, "_blank");
              }
            });

            labelContainer.appendChild(link);
            box.appendChild(labelContainer);
          } else {
            // Show "Processed by" for non-final images with annotations
            const labelContainer = document.createElement("div");
            labelContainer.className = "processed-by-text";
            labelContainer.style.fontSize = "8px";
            labelContainer.style.color = "#6B7280";
            labelContainer.style.marginTop = "3px";
            labelContainer.style.textAlign = "center";
            labelContainer.style.lineHeight = "1.3";
            labelContainer.textContent = `Processed by: ${initials}`;

            box.appendChild(labelContainer);
          }
        }
      }
    } catch (error) {
      console.error("Error adding grader initials to thumbnails:", error);
    }
  }
}
